import routes from '../app/routes';
import {
  newAirRetrievalGuard,
  newQuoteGuard,
  newShipmentGuard,
} from '../components/guards/pageGuards';

/**
 * Schema:
 *   rows: Row[]
 *   Row:     { titleId?, columns: Column[] }     // shared header across columns is optional
 *   Column:  Block[]
 *   Block:   Section | Group
 *   Section: { titleId, entries: Entry[], userGate?,
 *              disabledOnNarrow?: boolean, disabledTooltipId? }
 *   Group:   { groupTitleId, items: Item[], userGate? }
 *   Entry:   Item | Group
 *   Item:    { textId, to?, href?, drawerId?, disabled?, guard? }
 *
 * - `userGate(user) => boolean` hides the block entirely when falsy.
 * - `disabledOnNarrow` + `disabledTooltipId` on a Section: when viewport is narrow
 *   (sm or md), every item in the section renders as disabled and hovering shows
 *   the tooltip. Mirrors AccountDropdown's Accounting behavior.
 */
export const mainMenuConfig = {
  rows: [
    {
      columns: [
        [
          {
            titleId: 'mainMenu.section.shipping',
            entries: [
              { textId: 'menu.monitor', to: routes.monitor },
              {
                textId: 'menu.quote',
                to: routes.quoting.newQuote,
                guard: newQuoteGuard,
              },
              {
                groupTitleId: 'mainMenu.group.ship',
                items: [
                  {
                    textId: 'menu.place-order',
                    to: routes.book.newShipment,
                    guard: newShipmentGuard,
                  },
                  {
                    textId: 'menu.air-retrieval',
                    to: routes.book.newAirRetrieval,
                    guard: newAirRetrievalGuard,
                  },
                  // These features are not implemented in QOL2.0 - Uncomment when implemented
                  // { textId: 'mainMenu.item.aogOrder', disabled: true },
                  // {
                  //   textId: 'mainMenu.item.placeClinicalTrialOrder',
                  //   disabled: true,
                  // },
                  // { textId: 'mainMenu.item.holdForPickup', disabled: true },
                  // { textId: 'mainMenu.item.airCharterRfq', disabled: true },
                ],
              },
              // This feature are not implemented in QOL2.0 - Uncomment when implemented
              // { textId: 'mainMenu.item.documentCenter', disabled: true },
            ],
          },
          {
            titleId: 'mainMenu.section.accounting',
            userGate: user => user?.financeEnabled,
            disabledOnNarrow: true,
            disabledTooltipId: 'account.accounting.notAvailable',
            entries: [
              { textId: 'mainMenu.item.invoices', drawerId: 'account.invoice' },
              {
                textId: 'mainMenu.item.statement',
                drawerId: 'account.statement',
              },
            ],
          },
        ],
        [
          {
            titleId: 'mainMenu.section.addressBook',
            entries: [
              {
                textId: 'mainMenu.item.open',
                drawerId: 'account.addressBook',
              },
            ],
          },
          {
            titleId: 'mainMenu.section.templates',
            entries: [
              {
                textId: 'mainMenu.item.open',
                drawerId: 'account.templates',
              },
            ],
          },
          {
            titleId: 'mainMenu.section.reports',
            userGate: user => user?.reportsEnabled,
            entries: [
              {
                textId: 'mainMenu.item.open',
                drawerId: 'account.reports',
              },
            ],
          },
        ],
      ],
    },
    // Comment while Ed clarifies which links we should be using
    // {
    //   titleId: 'mainMenu.section.toolsAndExternalLinks',
    //   columns: [
    //     [
    //       {
    //         groupTitleId: 'mainMenu.group.routeTools',
    //         items: [
    //           { textId: 'mainMenu.item.routingGuide', disabled: true },
    //           { textId: 'mainMenu.item.flightGuide', disabled: true },
    //         ],
    //       },
    //       {
    //         groupTitleId: 'mainMenu.group.tools',
    //         items: [
    //           { textId: 'mainMenu.item.dailyCollectionEditor', disabled: true },
    //           { textId: 'mainMenu.item.willCallEditor', disabled: true },
    //           { textId: 'mainMenu.item.vipAvailability', disabled: true },
    //           { textId: 'mainMenu.item.uploadShipments', disabled: true },
    //         ],
    //       },
    //     ],
    //     [
    //       {
    //         groupTitleId: 'mainMenu.group.externalLinks',
    //         items: [
    //           {
    //             textId: 'mainMenu.item.quickOnlineFaq',
    //             href: externalLinks.helpDesk,
    //           },
    //           {
    //             textId: 'mainMenu.item.iosMobileApp',
    //             href: externalLinks.iosApp,
    //           },
    //           {
    //             textId: 'mainMenu.item.androidMobileApp',
    //             href: externalLinks.androidApp,
    //           },
    //           {
    //             textId: 'mainMenu.item.faaAirportStatus',
    //             href: externalLinks.faaAirportStatus,
    //           },
    //           {
    //             textId: 'mainMenu.item.nationalWeatherService',
    //             href: externalLinks.nationalWeatherService,
    //           },
    //           {
    //             textId: 'mainMenu.item.internationalWeatherService',
    //             href: externalLinks.internationalWeatherService,
    //           },
    //           {
    //             textId: 'mainMenu.item.usCustomsService',
    //             href: externalLinks.usCustomsService,
    //           },
    //           {
    //             textId: 'mainMenu.item.usPostalCodes',
    //             href: externalLinks.usPostalCodes,
    //           },
    //           { textId: 'mainMenu.item.usda', href: externalLinks.usda },
    //           { textId: 'mainMenu.item.usfda', href: externalLinks.usfda },
    //           { textId: 'mainMenu.item.flightArrivals', disabled: true },
    //           { textId: 'mainMenu.item.quickCorporateBlog', disabled: true },
    //           {
    //             textId: 'mainMenu.item.privacyPolicy',
    //             href: externalLinks.privacyPolicy,
    //           },
    //         ],
    //       },
    //     ],
    //   ],
    // },
  ],
};
